
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-partners",
      function () {
        return require("private-next-pages/our-partners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-partners"])
      });
    }
  